module.exports = __webpack_public_path__ + "img/gcw-logo.c47f761f.png";